<div class="auth-shell">
  <button type="button" class="auth-shell__lang-switch">
    <span aria-hidden="true">🌐</span>
    English
    <span class="auth-shell__caret" aria-hidden="true">▾</span>
  </button>

  <section class="auth-shell__visual">
    <a [routerLink]="routes.HOME" class="auth-shell__brand">
      <img src="/assets/images/login_logo1.png" alt="Amaalmomineen - Your Companion in Imaan" class="auth-shell__brand-logo" />
    </a>

    <div class="auth-shell__features">
      @for (feature of features; track feature.title) {
        <a [routerLink]="feature.path" class="auth-shell__feature">
          <span class="auth-shell__feature-icon" aria-hidden="true">{{ feature.icon }}</span>
          <strong>{{ feature.title }}</strong>
          <span>{{ feature.subtitle }}</span>
        </a>
      }
    </div>
  </section>

  <section class="auth-shell__panel">
    <ng-content></ng-content>
  </section>

  <footer class="auth-shell__footer">
    <span class="auth-shell__footer-secure">
      <span aria-hidden="true">🛡️</span>
      Your data is secure and private with us.
    </span>
    <div class="auth-shell__footer-links">
      <span>About Us</span>
      <span>Privacy Policy</span>
      <span>Terms &amp; Conditions</span>
      <span>Help Center</span>
    </div>
    <span class="auth-shell__footer-copy">&copy; 2024 Amaalmomineen. All rights reserved.</span>
  </footer>
</div>
